const incomeTypeOptions = [
  {
    value: "supplementary-income",
    label: "Supplementary Income",
  },
  { value: "rental-income", label: "Rental Income" },
  { value: "self-employment", label: "Self-Employment" },
  { value: "investment-income", label: "Investment Income" },
  { value: "other", label: "Other" },
];
const expensetypeOptions = [
  {
    value: "housing-expenses",
    label: "Housing Expenses",
  },
  {
    value: "living-expenses",
    label: "Living Expenses",
  },
  { value: "debt-repayment", label: "Debt repayment" },
  { value: "insurance", label: "Insurance" },
  { value: "eduction", label: "Eduction" },
  { value: "other", label: "Other" },
];
const maritalstatusOptions = [
  { value: "SINGLE", label: "Single" },
  { value: "MARRIED", label: "Married" },
  { value: "SEPARATED", label: "Separated" },
  // { value: "divorced", label: "Divorced" },
  // { value: "widowed", label: "Widowed" },
  { value: "DEFACTO", label: "De facto" },
];
const visastatusOptions = [
  { value: "Citizen", label: "Citizen" },
  { value: "Permanent", label: "Permanent" },
  { value: "Other", label: "Other" },
];
const stateOfIssueOptions = [
  { value: "NSW", label: "NSW" },
  { value: "NT", label: "NT" },
  { value: "QLD", label: "QLD" },
  { value: "VIC", label: "VIC" },
  { value: "SA", label: "SA" },
  { value: "TAS", label: "TAS" },
  { value: "WA", label: "WA" },
  { value: "ACT", label: "ACT" },
];
const HousingStatusOptions = [
  { value: "Owner", label: "Owner" },
  // { value: "Boarding", label: "Boarding" },
  { value: "Renting", label: "Renting" },
  { value: "Living with family", label: "Living with family" },
  { value: "Other", label: "Other" },
];
const CurrentemploymentOptions = [
  { value: "full-time", label: "Full Time" },
  { value: "part-time", label: "Part Time" },
  { value: "contractor", label: "Contractor" },
  // { value: "unemployed", label: "Unemployed" },
  // { value: "retired", label: "Retired" },
  { value: "casual", label: "Casual" },
  { value: "self-employed", label: "Self-Employed" },
  { value: "unemployed_or_retired", label: "Unemployed / Retired" },
];
const frequencyOptions = [
  { value: "weekly", label: "Weekly" },
  // { value: "fortnightly", label: "Fortnightly" },
  { value: "monthly", label: "Monthly" },
  { value: "annually", label: "Annually" },
];
const otherIncomeOptions = [
  { value: "car_allowance", label: "Car Allowance" },
  { value: "parental_leave_income", label: "Parental Leave income" },
  { value: "self_employed", label: "Self employed" },
  {
    value: "government_benefits_and_pensions",
    label: "Government benefits and pensions",
  },
  {
    value: "child_support",
    label: "Child support",
  },
  {
    value: "rental_income",
    label: "Rental income",
  },
  {
    value: "investment_income",
    label: "Investment Income",
  },
];

const relactionshipOptions = [
  { value: "spouse", label: "Spouse" },
  { value: "siblings", label: "Siblings" },
  // { value: "colleague", label: "Colleague" },
  { value: "child", label: "Child" },
  { value: "friend", label: "Friend" },
];

// const relactionshipOptions = [
//   { value: "wife", label: "Wife" },
//   { value: "brother", label: "Brother" },
//   { value: "friend", label: "Friend" },
//   { value: "colleague", label: "Colleague" },
// ];

const propertyTypeOptions = [
  { value: "house ", label: "House" },
  { value: "unit ", label: "Unit" },
  { value: "apartment ", label: "Apartment" },
  { value: "flat ", label: "Flat" },
  { value: "township ", label: "Township" },
  { value: "commercial ", label: "Commercial" },
];

const numberDependentsOptions = [
  { value: 0, label: "I don't have any" },
  { value: 1, label: 1 },
  { value: 2, label: 2 },
  { value: 3, label: 3 },
  { value: 4, label: 4 },
  { value: 5, label: 5 },
  { value: 6, label: 6 },
];

const loanTermsOptions = Array.from({ length: 20 }, (_, i) => {
  const value = (i + 1).toString();
  return {
    value,
    label: value,
  };
});
const holdersOptions = Array.from({ length: 4 }, (_, i) => {
  const value = (i + 1).toString();
  return {
    value,
    label: value,
  };
});
const RemainingloanTermOptions = Array.from({ length: 30 }, (_, i) => {
  const value = (i + 1).toString();
  return {
    value,
    label: value,
  };
});

const employmentTypeOptions = [
  { value: "probation ", label: "Probation" },
  { value: "permanent ", label: "Permanent" },
];

export {
  expensetypeOptions,
  incomeTypeOptions,
  maritalstatusOptions,
  visastatusOptions,
  stateOfIssueOptions,
  HousingStatusOptions,
  CurrentemploymentOptions,
  frequencyOptions,
  relactionshipOptions,
  otherIncomeOptions,
  propertyTypeOptions,
  loanTermsOptions,
  numberDependentsOptions,
  employmentTypeOptions,
  holdersOptions,
  RemainingloanTermOptions,
};
